<template>
    <Main>
        <div class="error-page error-page__admin">
            <div class="countdown-bg countdown-bg__admin"></div>
            <div class="error-screen">
                <h5 class="description-page">Welcome to our system<br />Good morning and full of energy.</h5>
            </div>
        </div>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
export default {
    name: 'home',
    data() {
        return {
            menuActive: ''
        };
    },
    components: {
        Main
    }
};
</script>
<style lang="scss" scoped>
#app {
    .countdown-bg {
        background-image: url('../assets/img/consulting.svg');
    }
}
</style>
